<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'b2b-table-menu-accountingclose-draft',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },
  computed: {

    ...mapGetters([
      'optionsFilterService'
    ]),

    // Columnas Tabla Borradores Cierres contables
    isShowServiceAccountingCloseDraft () {
      return this.$store.getters.isShowServiceAccountingCloseDraft
    },
    isShowBuyerAccountingCloseDraft () {
      return this.$store.getters.isShowBuyerAccountingCloseDraft
    },
    isShowNameAccountingCloseDraft () {
      return this.$store.getters.isShowNameAccountingCloseDraft
    },
    isShowStartDateAccountingCloseDraft () {
      return this.$store.getters.isShowStartDateAccountingCloseDraft
    },
    isShowEndDateAccountingCloseDraft () {
      return this.$store.getters.isShowEndDateAccountingCloseDraft
    },
    isShowStatusAccountingCloseDraft () {
      return this.$store.getters.isShowStatusAccountingCloseDraft
    },
    isShowChildNameAccountingCloseDraft () {
      return this.$store.getters.isShowChildNameAccountingCloseDraft
    }
  },
  methods: {
    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      switch (column) {
        case 'servicio':
          this.$store.dispatch('isShowServiceAccountingCloseDraft', !this.$store.getters.isShowServiceAccountingCloseDraft)
          break
        case 'comprador':
          this.$store.dispatch('isShowBuyerAccountingCloseDraft', !this.$store.getters.isShowBuyerAccountingCloseDraft)
          break
        case 'nombre':
          this.$store.dispatch('isShowNameAccountingCloseDraft', !this.$store.getters.isShowNameAccountingCloseDraft)
          break
        case 'fechaini':
          this.$store.dispatch('isShowStartDateAccountingCloseDraft', !this.$store.getters.isShowStartDateAccountingCloseDraft)
          break
        case 'fechafin':
          this.$store.dispatch('isShowEndDateAccountingCloseDraft', !this.$store.getters.isShowEndDateAccountingCloseDraft)
          break
        case 'estado':
          this.$store.dispatch('isShowStatusAccountingCloseDraft', !this.$store.getters.isShowStatusAccountingCloseDraft)
          break
        case 'hijo':
          this.$store.dispatch('isShowChildNameAccountingCloseDraft', !this.$store.getters.isShowChildNameAccountingCloseDraft)
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      this.columns = [{
        text: this.$t('accounting_closes.entity_table.project'), value: 'servicio', show: this.isShowServiceAccountingCloseDraft
      }, {
        text: this.$t('accounting_closes.entity_table.buyer'), value: 'comprador', show: this.isShowBuyerAccountingCloseDraft
      }, {
        text: this.$t('accounting_closes.entity_table.name'), value: 'nombre', show: this.isShowNameAccountingCloseDraft
      }, {
        text: this.$t('accounting_closes.entity_table.status'), value: 'estado', show: this.isShowStatusAccountingCloseDraft
      }, {
        text: this.$t('accounting_closes.entity_table.start_date'), value: 'fechaini', show: this.isShowStartDateAccountingCloseDraft
      }, {
        text: this.$t('accounting_closes.entity_table.end_date'), value: 'fechafin', show: this.isShowEndDateAccountingCloseDraft
      }, {
        text: this.$t('accounting_closes.entity_table.child_accounting_close_name'), value: 'hijo', show: this.isShowChildNameAccountingCloseDraft
      }
      ]
      // Si el usuario sólo tiene un servicio, quitamos el checkbox de servicios
      if (this.optionsFilterService.length < 2) {
        this.columns.splice(0, 1)
        this.$store.dispatch('isShowServiceAccountingCloseDraft', false)
      } else {
        this.$store.dispatch('isShowServiceAccountingCloseDraft', true)
      }
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
  .ods-dropdown {
      display: flex;
  }
  .desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
